import lodashPadStart from 'lodash-es/padStart';
import lodashToString from 'lodash-es/toString';

export const leadingZeros = (n: number): string => lodashPadStart(lodashToString(n), 2, '0');
